import { useTranslation } from 'react-i18next';
import { ReactComponent as InstructionIcon } from '../../../icons/instruction-sm.svg';
import { ReactComponent as ConfirmationIcon } from '../../../icons/confirmation.svg';
import './FilingArchiveTab.scss';
import Tooltip from '../../../components/Tooltip/Tooltip';
import { useModal } from '../../../components/Modal/useModal';
import CountryDetailsInstructionModal from './CountryDetailsInstructionModal';
import CountryDetailsPaymentConfirmationModal from './CountryDetailsPaymentConfirmationModal';
import { formatDate, formatNumber } from '../../../core/helpers';

const ITEMS = [
  {
    period: new Date(2022, 1, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 155050, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2022, 0, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 9200, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 11, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 249900, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 10, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 111000, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 9, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 85000, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 8, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 85000, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 7, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 84800, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 6, 25),
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    vat_paid: { amount: 100100, currency: 'PLN' },
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 5, 25),
    vat_paid: { amount: 102100, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 4, 25),
    vat_paid: { amount: 109900, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 3, 25),
    vat_paid: { amount: 119200, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 2, 25),
    vat_paid: { amount: 109900, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 1, 25),
    vat_paid: { amount: 100900, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2021, 0, 25),
    vat_paid: { amount: 109100, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
  {
    period: new Date(2020, 11, 25),
    vat_paid: { amount: 199100, currency: 'PLN' },
    filing_started: new Date(2022, 3, 15),
    filed_on: new Date(2022, 3, 15),
    files: '',
    status: 'Closed',
  },
];

export default function FilingArchiveTab() {
  const { t } = useTranslation();

  const {
    isModalOpened: isCountryDetailsInstructionModalOpened,
    closeModal: closeCountryDetailsInstructionModal,
    openModal: openCountryDetailsInstructionModal,
  } = useModal();

  const {
    isModalOpened: isPaymentConfirmationModalOpened,
    closeModal: closePaymentConfirmationModal,
    openModal: openPaymentConfirmationModal,
  } = useModal();

  return (
    <div className='FilingArchiveTab'>
      <div className='FilingArchiveTab__grid d-grid mb-2 Text--gray mx-n3'>
        <div className='px-3'>{t('Period')}</div>
        <div className='px-3'>{t('Filing started')}</div>
        <div className='px-3'>{t('Filed on')}</div>
        <div className='px-3'>{t('VAT paid')}</div>
        <div className='px-3'>{t('Files')}</div>
        <div className='px-3'>{t('Status')}</div>
      </div>
      {ITEMS.map((item, i) => (
        <div className='FilingArchiveTab__grid d-grid mb-3 mx-n3' key={i}>
          <div className='px-3'>{formatDate(item.period, 'MMM yyyy')}</div>
          <div className='px-3'>
            {formatDate(item.filing_started, 'dd.MM.yyyy')}
          </div>
          <div className='px-3'>{formatDate(item.filed_on, 'dd.MM.yyyy')}</div>
          <div className='px-3'>
            {formatNumber(item.vat_paid.amount / 100, {
              currency: item.vat_paid.currency,
            })}
          </div>
          <div className='px-3'>
            <Tooltip
              content={
                <div className='Text--sm'>{t('Payment instruction')}</div>
              }
            >
              <button
                className='p-0 bg-transparent border-0 me-2 FilingArchiveTab__btn'
                onClick={openCountryDetailsInstructionModal}
              >
                <InstructionIcon />
              </button>
            </Tooltip>
            <Tooltip
              content={
                <div className='Text--sm'>{t('Payment confirmation')}</div>
              }
            >
              <button
                className='p-0 bg-transparent border-0 FilingArchiveTab__btn'
                onClick={openPaymentConfirmationModal}
              >
                <ConfirmationIcon />
              </button>
            </Tooltip>
          </div>
          <div className='px-3'>
            <div className='FilingArchiveTab__badge px-2 d-inline-block rounded'>
              {item.status}
            </div>
          </div>
        </div>
      ))}
      <CountryDetailsInstructionModal
        isModalOpened={isCountryDetailsInstructionModalOpened}
        closeModal={closeCountryDetailsInstructionModal}
      />
      <CountryDetailsPaymentConfirmationModal
        isModalOpened={isPaymentConfirmationModalOpened}
        closeModal={closePaymentConfirmationModal}
      />
    </div>
  );
}
